/* eslint-disable */
import React, {useEffect} from "react"
import {RouteComponentProps, withRouter} from "react-router"
import useTranslation from "../../../hooks/useTranslation"
import {Container} from "./styles"
type PropsType = RouteComponentProps & {}

const PageNotFound: React.FC<PropsType> = (props: PropsType) => {
  let [_translate, locale] = useTranslation()
  const [errorText, setErrorText] = React.useState<string>("")

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const error_code = urlParams.get("error_code")
    setErrorText(error_code || "")
  }, [])

  return (
    <Container className="error-page">
      <div className="error-logo">
        <svg
          width="148"
          height="44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.697 44c6.356 0 10.959-3.392 10.959-8.13 0-3.16-1.753-5.251-5.787-5.809l-8.197-1.208c-1.009-.14-1.666-.604-1.666-1.394 0-.557.438-1.115 1.096-1.347.833.186 1.797.279 2.805.279 5.436 0 9.031-2.974 9.031-7.527 0-1.534-.394-2.927-1.184-4.043h2.105l3.507-2.787h-9.294c-1.227-.465-2.63-.697-4.165-.697-5.436 0-9.03 2.973-9.03 7.527 0 3.299 1.885 5.761 4.997 6.876-2.28.837-3.857 2.649-3.857 4.647 0 1.672 1.052 2.973 2.63 3.716C1.534 34.986 0 36.427 0 38.425 0 41.723 4.384 44 10.697 44Zm-6.05-7.016c0-1.069.394-1.951 1.096-2.462.35.093.657.186 1.008.232l8.943 1.3c2.148.373 2.937 1.163 2.937 2.51 0 2.044-2.762 3.392-6.444 3.392-4.603 0-7.54-2.23-7.54-4.972Zm1.797-18.12c0-3.857 1.271-6.133 3.463-6.133s3.464 2.276 3.464 6.133c0 3.856-1.272 6.086-3.464 6.086s-3.463-2.23-3.463-6.086ZM23.72 34.94h11.09c-2.499-2.37-2.499-2.37-2.499-3.81V0l-8.723 3.02c2.63 1.626 2.63 1.626 2.63 3.299v24.81c0 1.441 0 1.441-2.499 3.81ZM36.607 34.94h11.047C45.2 32.57 45.2 32.57 45.2 31.13V11.337l-8.723 2.973c2.586 1.673 2.586 1.673 2.586 3.346V31.13c0 1.44 0 1.44-2.455 3.81Zm1.841-29.83c0 2.231 1.578 3.81 3.683 3.81 2.104 0 3.682-1.579 3.682-3.81 0-2.136-1.578-3.809-3.682-3.809-2.105 0-3.683 1.673-3.683 3.81ZM60.164 35.637c4.691 0 7.979-2.834 8.812-7.388-1.447 1.998-3.814 2.88-6.006 2.88-4.778 0-7.716-3.763-7.716-9.617 0-4.878 2.28-7.899 5.524-7.899 2.937 0 5.085 1.859 7.715 6.552v-6.69c-1.71-1.348-4.252-2.138-7.32-2.138-6.84 0-11.574 5.157-11.574 12.591 0 6.877 3.99 11.709 10.565 11.709ZM88.301 34.94h7.979c-1.93-1.998-1.93-1.998-3.157-3.764l-7.978-10.965 5.392-4.553c2.016-1.72 2.016-1.72 4.997-3.624H85.89c2.718 2.927 2.718 2.927.044 5.157l-6.488 5.343L88.3 34.94ZM70.722 3.02c2.63 1.626 2.63 1.626 2.63 3.299v24.81c0 1.441 0 1.441-2.498 3.81h11.09c-2.498-2.369-2.498-2.369-2.498-3.81V0l-8.724 3.02ZM108.268 35.637c6.883 0 11.749-5.018 11.749-12.173 0-7.156-4.822-12.127-11.749-12.127-6.926 0-11.748 4.971-11.748 12.127 0 7.108 4.866 12.173 11.748 12.173Zm-5.26-13.707c0-5.622 1.753-8.688 4.91-8.688 3.507 0 5.655 4.414 5.655 11.848 0 5.575-1.754 8.642-4.91 8.642-3.551 0-5.655-4.368-5.655-11.802ZM136.953 34.94H148c-2.455-2.37-2.455-2.37-2.455-3.81V19.189c0-4.507-2.63-7.852-6.926-7.852-3.157 0-5.962 2.137-7.584 4.971v-4.971l-8.724 2.973c2.586 1.673 2.586 1.673 2.586 3.346V31.13c0 1.44 0 1.44-2.455 3.81h11.048c-2.455-2.37-2.455-2.37-2.455-3.81V17.098c.92-1.115 2.367-1.905 4.12-1.905 2.455 0 4.253 1.58 4.253 5.018V31.13c0 1.44 0 1.44-2.455 3.81Z"
            fill="#010928"
          ></path>
        </svg>
      </div>
      {errorText ? (
        <div className="error-wrapper">
          <div>
            <p>Error - {errorText}</p>
            <p>
              C'è stato un errore durante il tentativo di login, per favore
              riprova più tardi o se l'errore persiste scrivici a
              <b style={{marginLeft: "5px"}}>
                <u>support@glickon.com</u>
              </b>
            </p>
          </div>
        </div>
      ) : (
        <div className="error-wrapper">
          <div>
            <p>Page not found</p>
            <p>
              La pagina che cercavi di raggiungere non è stata trovata su questo sito, se l'errore persiste scrivici a
              <b style={{marginLeft: "5px"}}>
                <u>support@glickon.com</u>
              </b>
            </p>
          </div>
        </div>
      )}
      <div className="error-footer">
        <p>
          Via Nino Bixio, 7, 20129 Milano MI - Copyright © 2022 glickon S.p.A.
          All rights reserved - VAT Number: 08573820969
        </p>
      </div>
    </Container>
  )
}

export default withRouter<PropsType, React.FC<PropsType>>(PageNotFound)
